import ClientId from '~/constants/ClientId';
import didSetNativeAppCapabilities from '~/constants/common/didSetNativeAppCapabilities';
import KubernetesAppName from '~/constants/common/KubernetesAppName';
import { getAppCapabilitiesCookieName } from '~/native/utils';
import BrowserCookies from '~/utilities/BrowserCookies';
import getBranchCookieName from './getBranchCookieName';
import getEnabledCookieName from './getEnabledCookieName';

export default function clearAllFeatureCookies() {
  Object.values(KubernetesAppName).forEach(appName => {
    BrowserCookies.remove(getEnabledCookieName(appName));
    BrowserCookies.remove(getBranchCookieName(appName));
  });

  Object.values(ClientId).forEach(clientId => {
    BrowserCookies.remove(getAppCapabilitiesCookieName(clientId));

    const didSetCookieName = didSetNativeAppCapabilities[clientId];

    if (didSetCookieName) {
      BrowserCookies.remove(didSetCookieName);
    }
  });

  window.location.reload();
}
